export default __webpack_public_path__ + "static/media/delete-red.1024f335.svg";